import { spacing, ThemeUICSSObject } from '@apia/theme';

const filtersSetters: ThemeUICSSObject = {
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  gap: 3,
  '.savedFilters_container': {
    '.chkNewFilterGroup': {
      flexDirection: 'row-reverse',
      justifyContent: 'start',
      gap: 3,
    },
    '.savedFiltersCombo__container': {
      flexDirection: 'column',
      gap: 3,
      alignItems: 'start',
      '.savedFiltersCombo': {
        width: '100%',
      },
    },
    width: '100%',
    gridColumn: '1 / span 2',
    border: '1px solid',
    borderColor: 'palette.border.section',
    padding: '10px',
    marginBottom: '10px',
  },
  '.filterDateValue_container': {
    border: '1px solid',
    borderColor: 'palette.border.section',
    padding: '10px',
    '.dynamicDatesChk': {
      flexDirection: 'row-reverse',
      justifyContent: 'start',
      gap: 3,
    },
  },
  '.dateFilter_container': {
    gridColumn: '1 / span 2',
    width: '100%',
  },
  '.dateFrom, .dateTo': {
    width: '50%',
    '.amountFields_container': {
      display: 'flex',
      gap: spacing(2),
      width: '100%',
      Label: {
        flexGrow: 1,
      },
    },
  },
  '.fixedOptions_container': {
    gap: spacing(3),
    '> *': {
      width: '50%',
    },
  },
  '.startOfOptions_container': {
    gap: spacing(3),
    '> *': {
      width: '50%',
    },
  },
  '.requiredFilter__Border': {
    borderLeftStyle: 'solid !important',
    borderLeftWidth: '4px !important',
    borderLeftColor: 'palette.error.main',
  },
  '.requiredMark': {
    color: 'danger',
  },
};

export default filtersSetters;
